import { FC, useRef } from 'react'
import * as cn from 'classnames'
import { useDateSegment } from '@react-aria/datepicker'
import { DateFieldState, DateSegment as DateSegmentType } from '@react-stately/datepicker'
import * as styles from 'components/atoms/inputs/DatePicker/DateField.styl'

type DateSegmentProps = {
  segment: DateSegmentType
  state: DateFieldState
}

export const DateSegment: FC<DateSegmentProps> = ({ segment, state }) => {
  const ref = useRef(null)
  const { segmentProps } = useDateSegment(segment, state, ref)

  return (
    <div
      { ...segmentProps }
      ref={ ref }
      className={ cn(styles.segment, { [styles.placeholder]: segment.isPlaceholder }) }
    >
      {segment.text}
    </div>
  )
}
